Apt.fn.extend('maps', {
	/**
	 * Hover selected pin
	 *
	 * @param {Array} [center]
	 */
	hover(center) {
		const scope = this;

		if (! scope.map || ! scope.map.isStyleLoaded() || ! scope.map.getLayer('markers')) {
			return;
		}

		const priv = scope.$private;
		const options = {
			validate: false
		};

		let opacity = 1;
		let radius = 8;

		scope.$public.ready(() => {
			priv.createHoverLayer();

			if (scope.hoverFrame) {
				cancelAnimationFrame(scope.hoverFrame);
				clearTimeout(scope.hoverTimeout);

				scope.map.setPaintProperty('hovered', 'circle-opacity', 0, options);
				scope.map.setPaintProperty('hovered', 'circle-radius', radius, options);
			}

			scope.map.getSource('hovered')
				.setData(center ? {
					type: 'FeatureCollection',
					features: [{
						type: 'Feature',
						properties: {},
						geometry: {
							type: 'Point',
							coordinates: center
						}
					}]
				} : priv.empty);

			if (center) {
				let frame = 0;

				const animate = () => {
					scope.hoverTimeout = setTimeout(() => {
						if (! scope.map || ! scope.map.isStyleLoaded() || ! scope.map.getLayer('hovered')) {
							return;
						}

						frame++;

						radius += (40 - radius) / 25;
						opacity -= (0.9 / 25);

						scope.map.setPaintProperty('hovered', 'circle-opacity', Math.max(opacity, 0), options);
						scope.map.setPaintProperty('hovered', 'circle-radius', radius, options);

						if (opacity <= 0) {
							if (frame > 120) {
								scope.hover();

								return;
							}

							radius = 5;
							opacity = 1;
						}

						scope.hoverFrame = requestAnimationFrame(animate);
					}, 20);
				};

				animate();
			}
		});
	}
}, {
	/**
	 * Create hover layer
	 */
	createHoverLayer() {
		const scope = this;

		if (scope.map.getSource('hovered')) {
			return;
		}

		scope.addSource('hovered', {
			type: 'geojson',
			data: scope.empty
		});

		scope.addLayer({
			id: 'hovered',
			type: 'circle',
			source: 'hovered',
			paint: {
				'circle-color': '#f2f9f5',
				'circle-opacity-transition': {
					duration: 0
				},
				'circle-radius-transition': {
					duration: 0
				}
			}
		}, 'markers');
	}
});